import { useCallback } from 'react';
import { useLogOutUser } from 'pages/Auth/hooks/useAuthActions';

interface UseSignOutActionOptions {
  noRedirect?: boolean;
  onBeforeSignOut?: () => void;
  redirectTo?: string;
}

const useSignOutAction = ({
  noRedirect = false,
  onBeforeSignOut,
  redirectTo,
}: UseSignOutActionOptions = {}) => {
  const logOutUser = useLogOutUser({ noRedirect, redirectTo });

  return useCallback(() => {
    onBeforeSignOut?.();
    logOutUser();
  }, [logOutUser, onBeforeSignOut]);
};

export default useSignOutAction;
